import {
  GET_LAYOUT_DATA_SUCCESS,
} from "cityads-v3/actions/menu";

import {
  SET_PHONE,
  SET_CODE,

  RESET_SMS_STATE,

  EXPIRE_SMS_CODE,

  REQUEST_WITH_SMS_CONFIRMATION,
  REQUEST_WITH_SMS_CONFIRMATION_SUCCESS,
  REQUEST_WITH_SMS_CONFIRMATION_FAIL,

  REQUEST_CONFIRMATION_CODE,
  REQUEST_CONFIRMATION_CODE_SUCCESS,
  REQUEST_CONFIRMATION_CODE_FAIL,

  RESET_CONFIRMED_PHONE_SUCCESS,

  CONFIRM_PHONE_SUCCESS,

  CLEAN_ERRORS,

  CLEAN_LAST_CODE_REQUEST_TIME,
} from 'cityads-v3/actions/sms';

import {
  SMS_RESULT_OK,
  SMS_RESULT_NO_ATTEMPTS_LEFT,
  SMS_RESULT_WRONG_CODE,
  SMS_RESULT_SEND_CODE_SUCCESS,
  SMS_RESULT_PHONE_NOT_FOUND,
  SMS_RESULT_ERROR,
  SMS_RESULT_REQUIRES_OLD_PHONE_CONFIRMATION,

  SMS_STATE_IDLE,
  SMS_STATE_WAITING,
  SMS_STATE_AWAITING_FIRST_CODE_REQUEST,
  SMS_STATE_AWAITING_REPEATED_CODE_REQUEST,
  SMS_STATE_ENTERING_CODE,
  SMS_STATE_AWAITING_CODE_SEND,
} from 'cityads-v3/utils/smsUtils';

const initialState = {
  phone: '',
  code: '',

  isCodeWrong: false,

  isPhoneConfirmed: false,

  smsState: SMS_STATE_IDLE,

  lastCodeRequestTime: null,

  errors: [],
};

export default function sms(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LAYOUT_DATA_SUCCESS:
      return {
        ...state,
        isPhoneConfirmed: action.response.user.phoneVerified ?? false,
      };

    case SET_PHONE:
      return {
        ...state,
        phone: action.phone
      };

    case SET_CODE:
      return {
        ...state,
        code: action.code,
        isCodeWrong: false,
      };

    case RESET_SMS_STATE:
      return {
        ...state,
        code: '',
        isCodeWrong: false,
        smsState: SMS_STATE_IDLE,
        errors: [],
      };

    case EXPIRE_SMS_CODE:
      return {
        ...state,
        code: '',
        isCodeWrong: false,
        smsState: SMS_STATE_WAITING,
        errors: [],
      };

    case REQUEST_WITH_SMS_CONFIRMATION:
      if (!state.isPhoneConfirmed && !state.phone) {
        switch (state.smsState) {
          case SMS_STATE_IDLE:
            return {
              ...state,
              smsState: SMS_STATE_WAITING,
              errors: [],
            };
          default:
            return state;
        }
      }

      switch (state.smsState) {
        case SMS_STATE_IDLE:
          return {
            ...state,
            smsState: SMS_STATE_IDLE,
            errors: [],
          };

        case SMS_STATE_WAITING:
          return {
            ...state,
            smsState: SMS_STATE_AWAITING_FIRST_CODE_REQUEST,
            errors: [],
          };

        case SMS_STATE_ENTERING_CODE:
          return {
            ...state,
            smsState: SMS_STATE_AWAITING_CODE_SEND,
            errors: [],
          };

        default:
          return state;
      }

    case REQUEST_WITH_SMS_CONFIRMATION_SUCCESS:
      switch (action.response.sms?.result) {
        case SMS_RESULT_OK:
          return {
            ...state,
            code: '',
            isCodeWrong: false,
            isPhoneConfirmed: !action.additional.isReset,
            smsState: SMS_STATE_IDLE,
            errors: [],
          };
        case SMS_RESULT_NO_ATTEMPTS_LEFT:
          return {
            ...state,
            code: '',
            isCodeWrong: false,
            smsState: SMS_STATE_WAITING,
            errors: ['sms.errors.no_attempts_left'],
            errorsTranslated: false,
            lastCodeRequestTime: null,
          };
        case SMS_RESULT_WRONG_CODE:
          return {
            ...state,
            isCodeWrong: true,
            smsState: SMS_STATE_ENTERING_CODE,
            errors: ['sms.errors.wrong_code'],
            errorsTranslated: false,
          };
        case SMS_RESULT_SEND_CODE_SUCCESS:
          return {
            ...state,
            isCodeWrong: false,
            smsState: SMS_STATE_ENTERING_CODE,
            errors: [],
            lastCodeRequestTime: Number(new Date()),
          };
        case SMS_RESULT_PHONE_NOT_FOUND:
          return {
            ...state,
            phone: '',
            code: '',
            isCodeWrong: false,
            isPhoneConfirmed: false,
            smsState: SMS_STATE_WAITING,
            errors: [],
          };
        case SMS_RESULT_ERROR: {
          let nextSmsState;

          switch (state.smsState) {
            case SMS_STATE_AWAITING_CODE_SEND:
            case SMS_STATE_AWAITING_FIRST_CODE_REQUEST:
              nextSmsState = SMS_STATE_WAITING;
              break;
            default:
              nextSmsState = SMS_STATE_ENTERING_CODE;
              break;
          }

          return {
            ...state,
            smsState: nextSmsState,
            errors: [action.response.sms?.error],
            errorsTranslated: true,
          };
        }
        case SMS_RESULT_REQUIRES_OLD_PHONE_CONFIRMATION:
          return {
            ...state,
            code: '',
            isCodeWrong: false,
            isPhoneConfirmed: true,
            smsState: SMS_STATE_WAITING,
            errors: ['sms.errors.confirmation_required'],
            errorsTranslated: false,
            lastCodeRequestTime: null,
          };
        default:
          return state;
      };

    case REQUEST_WITH_SMS_CONFIRMATION_FAIL:
      // ошибка, не связанная с SMS, закрываем окно и обрабатываем ошибку вне обёртки
      return {
        ...state,
        // закрывая окно SMS, очищаем введённый код, чтобы не пугать человека
        code: '',
        isCodeWrong: false,
        // Если телефон не был подтверждён, подтверждение удалось.
        // Если мы ошиблись (например, ошибка сети) - не страшно, в следующий раз сервер вернёт SMS_RESULT_PHONE_NOT_FOUND
        isPhoneConfirmed: true,
        smsState: SMS_STATE_IDLE,
        errors: [],
      };

    case REQUEST_CONFIRMATION_CODE:
      switch (state.smsState) {
        case SMS_STATE_WAITING:
          return {
            ...state,
            smsState: SMS_STATE_AWAITING_FIRST_CODE_REQUEST,
            errors: [],
          };
        case SMS_STATE_ENTERING_CODE:
          return {
            ...state,
            smsState: SMS_STATE_AWAITING_REPEATED_CODE_REQUEST,
            errors: [],
          };
        default:
          return state;
      };

    case REQUEST_CONFIRMATION_CODE_SUCCESS:
      return {
        ...state,
        smsState: SMS_STATE_ENTERING_CODE,
        lastCodeRequestTime: Number(new Date()),
        errors: [],
      };

    case REQUEST_CONFIRMATION_CODE_FAIL:
      switch (state.smsState) {
        case SMS_STATE_AWAITING_FIRST_CODE_REQUEST:
          return {
            ...state,
            smsState: SMS_STATE_WAITING,
            errors: action.response.errors || [action.response.message],
            errorsTranslated: true,
          };
        case SMS_STATE_AWAITING_REPEATED_CODE_REQUEST:
          return {
            ...state,
            smsState: SMS_STATE_ENTERING_CODE,
            errors: action.response.errors || [action.response.message],
            errorsTranslated: true,
          };
        default:
          return state;
      }

    case CLEAN_ERRORS:
      return {
        ...state,
        errors: [],
      };

    case RESET_CONFIRMED_PHONE_SUCCESS:
      switch (state.smsState) {
        case SMS_STATE_IDLE:
          return {
            ...state,
            phone: '',
            code: '',
            isCodeWrong: false,
            isPhoneConfirmed: false,
            smsState: SMS_STATE_WAITING,
            errors: [],
          };
        default:
          return state;
      }

    case CONFIRM_PHONE_SUCCESS:
      switch (state.smsState) {
        case SMS_STATE_ENTERING_CODE:
          if (action.response.sms?.result === SMS_RESULT_SEND_CODE_SUCCESS && !state.phone) {
            return {
              ...state,
              code: '',
              isCodeWrong: false,
              isPhoneConfirmed: true,
              smsState: SMS_STATE_ENTERING_CODE,
              errors: [],
            };
          } else {
            return state;
          }
        default:
          return state;
      }

    case CLEAN_LAST_CODE_REQUEST_TIME:
      return {
        ...state,
        lastCodeRequestTime: null,
      };

    default:
      return state;
  }
}
